module.exports = __webpack_public_path__ + "img/Add Patient - Gray - Selected.151e04a5.png";